// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A9-E","colBig":"styles_colBig__10H6u","colSmall":"styles_colSmall__hVNqI","shopifyNameWrapper":"styles_shopifyNameWrapper__3llBs"};